// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useUserPermissionsOnCurrentScenario } from '../../../hooks/SecurityHooks';
import { useOrganizationId } from '../../../state/hooks/OrganizationHooks';
import { useCurrentScenarioData } from '../../../state/hooks/ScenarioHooks';
import {
  useAssetClassesList,
  useAssetClassAttrsByGisement,
  useDeleteGisement,
  useGisements,
  useGestionActivites,
  useInitializeGisementTwingraphQueries,
  useSetNewTableNamesMapping,
  useTechnicalPolicies,
  useTwingraphQueriesStatus,
  useUpdateGisementData,
  useClasseActifAttributeValuesByGisement,
  useAssetClassAttributesWithDescendants,
  useAssetClassAttributesValuesWithDescendants,
} from '../../../state/wizard/WizardHooks';
import { useSaveWizardData } from './SaveWizardDataHook';

export const useWizard = (selectedGisement) => {
  const organizationId = useOrganizationId();
  const scenarioData = useCurrentScenarioData();
  const scenarioId = scenarioData.id;
  const datasetId = scenarioData.datasetList[0];
  const technicalPolicyData = useTechnicalPolicies(scenarioId);
  const getGisementData = useInitializeGisementTwingraphQueries();
  const gisements = useGisements(scenarioId);
  const gestionActivites = useGestionActivites(scenarioData.id);
  const assetClassesList = useAssetClassesList(scenarioData.id);
  const assetClassAttrsByGisement = useAssetClassAttrsByGisement(selectedGisement, scenarioId);
  const { saveData } = useSaveWizardData(selectedGisement);
  const setNewTableNamesMapping = useSetNewTableNamesMapping();
  const userPermissionsOnCurrentScenario = useUserPermissionsOnCurrentScenario();
  const updateGisementData = useUpdateGisementData();
  const deleteGisement = useDeleteGisement();
  const status = useTwingraphQueriesStatus();
  const assetClassAttributeValues = useClasseActifAttributeValuesByGisement(selectedGisement, scenarioId);
  const assetClassAttributesWithDescendants = useAssetClassAttributesWithDescendants(selectedGisement, scenarioId);
  const assetClassAttributesValuesWithDescendants = useAssetClassAttributesValuesWithDescendants(
    selectedGisement,
    scenarioId
  );
  return {
    technicalPolicyData,
    getGisementData,
    gisements,
    organizationId,
    datasetId,
    scenarioData,
    assetClassAttrsByGisement,
    assetClassAttributeValues,
    assetClassAttributesWithDescendants,
    assetClassAttributesValuesWithDescendants,
    saveData,
    gestionActivites,
    assetClassesList,
    setNewTableNamesMapping,
    userPermissionsOnCurrentScenario,
    updateGisementData,
    deleteGisement,
    status,
  };
};
